import { render, staticRenderFns } from "./optional.vue?vue&type=template&id=7fdb905a&scoped=true"
import script from "./optional.vue?vue&type=script&lang=ts"
export * from "./optional.vue?vue&type=script&lang=ts"
import style0 from "./optional.vue?vue&type=style&index=0&id=7fdb905a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdb905a",
  null
  
)

export default component.exports